import { useOpenAutopilotUpgrade } from 'hooks/useOpenAutopilotUpgrade'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Button } from 'blaze-ui/Button'
import LockOpen3 from 'blaze-ui/icons/24/LockOpen3'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

export const AutopilotUpgradeRemoveWatermarkButton = () => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const openVirtualMarketerPlansModal = useOpenAutopilotUpgrade()
  const workspace = useCurrentWorkspace()

  if (workspace?.is_ap_freemium) {
    return (
      <Button
        variant={isSystemRedesignEnabled ? 'secondary' : 'tertiary'}
        size="md"
        onPress={() => openVirtualMarketerPlansModal()}
        frontIcon={LockOpen3}
        fullWidth
      >
        Remove Watermark
      </Button>
    )
  }

  return <></>
}
